import { Either, Maybe } from 'monet';

/**
 * @description Шлюз истории действий сотрудников.
 * @param {Axios} axios HTTP клиент.
 * @constructor
 */
export default function EmployeeActionHistoryGateway(axios) {
  /**
   * @description Показать опции фильтров.
   * @returns {Promise<Maybe>}
   */
  this.viewOptions = () => axios
    .get('/api/action-history/filter-options')
    .then((response) => Maybe.of(response.data));

  /**
   * @description Получить историю действий.
   * @param {string}   from
   * @param {string}   to
   * @param {number[]} employeeIds
   * @param {string[]} actions
   * @param {string}   sort
   * @param {string}   searchQuery
   * @returns {Promise<Either>}
   */
  this.viewHistoryActions = (
    from,
    to,
    employeeIds,
    actions,
    sort,
    searchQuery,
  ) => axios
    .post(
      `/api/action-history/${from}:${to}`,
      {
        employee_ids: employeeIds,
        actions,
        sort,
        search_query: searchQuery,
      },
    ).then(
      (response) => Either.Right(response.data),
      (error) => {
        if (error.isAxiosError && [400, 403].includes(error.response.status)) {
          return Either.Left(error.response.data);
        }
        throw error;
      },
    );
}
